(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stockists"]) return;
  try {
    
var titles = {
  'online-': 'ONLINE STOCKISTS',
  'Netherlands-': 'Netherlands – Amsterdam',
  'TURKEY-': 'TURKEY',
  'jordan-': 'Jordan',
  'DUBAI-': 'Dubai',
  'QATAR-': 'Qatar',
  'SPAIN-': 'Spain',
  'ITALY-': 'Italy',
  'australia-tas': 'TAS',
  'singapore-': 'SINGAPORE',
  'mexico-': 'MEXICO',
  'LEBANON-': 'Lebanon',
  'canada-': 'CANADA',
  'uk-': 'United Kingdom',
  'australia-nsw': 'NEW SOUTH WALES',
  'australia-nt': 'NORTHERN TERRITORY',
  'australia-qld': 'QUEENSLAND',
  'australia-sa': 'SOUTH AUSTRALIA',
  'australia-vic': 'VICTORIA',
  'australia-wa': 'WESTERN AUSTRALIA',
  'usa-ca': 'CALIFORNIA',
  'usa-ky': 'KENTUCKY',
  'usa-ms': 'MISSISSIPPI',
  'usa-ct': 'CT',
  'usa-ma': 'MA',
  'usa-mi': 'MICHIGAN',
  'usa-new-jersey': 'NEW JERSEY',
  'usa-fl': 'FLORIDA',
  'usa-al': 'Alabama',
  'usa-tx': 'Texas',
  'usa-la': 'Louisiana',
  'usa-nc': 'North Carolina',
  'usa-nj': 'NEW JERSEY',
  'usa-ny': 'NEW YORK',
  'usa-ar': 'ARKANSAS',
  'usa-pa': 'PENNSYLVANIA',
  'usa-sa': 'SOUTH AMERICA'
};

$(document).ready(function () {
  $(document).on('click', '.stockmenu a', function (e) {
    e.preventDefault();

    if ($(this).data('filter') == '') {
      $(this).find('ul').toggleClass('active');
    } else {
      console.log($(this).data('filter'));

      $('.stockists .item').removeClass('active');
      $('.stockists .item.' + $(this).data('filter')).addClass('active');

      // $('#add_list li').removeClass('active');
      // $('#add_list li.' + $(this).data('filter')).addClass('active');

      $('.stockpage .right h1').html(titles[$(this).data('filter')]);

      // for (let i = 0; i < markers.length; i++) {
      //   markers[i].setMap(null);
      // }
      // markers = [];

      // var infowindow = new google.maps.InfoWindow();
      // var bounds = new google.maps.LatLngBounds();

      // var marker, i;

      // $('#add_list li.active').each(function () {
      //   console.log(23424);
      //   var lat = $(this).attr('data-lat');
      //   var long = $(this).attr('data-long');

      //   let marLatLng = new google.maps.LatLng(lat, long);
      //   marker = new google.maps.Marker({
      //     position: marLatLng,
      //     map: map
      //   });

      //   markers.push(marker);
      //   bounds.extend(marLatLng);

      //   (function(marker, $li){
      //     google.maps.event.addListener(marker, 'click', function () {
      //       // Build content and open infowindow
      //       var name = $li.find('.al_top h3.name').text() || '';
      //       var addr = $li.find('.al_top p').html() || '';
      //       var content = '<div><strong>' + name.trim() + '</strong></div><div>' + addr + '</div>';
      //       infowindow.setContent(content);
      //       infowindow.open(map, marker);
      //       map.panTo(marker.getPosition());
      //       var z = $li.attr('data-zoom');
      //       map.setZoom(z ? parseInt(z,10) : 16);

      //       // Highlight and scroll the list item
      //       try {
      //         $('#add_list li').removeClass('activeLocation');
      //         $li.addClass('activeLocation');
      //         if ($li && $li[0] && $li[0].scrollIntoView) $li[0].scrollIntoView({behavior: 'smooth', block: 'center'});
      //       } catch (e) {}
      //     });
      //   })(marker, $(this));
      // });

      // map.fitBounds(bounds);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
